export class CamerasRegister {
  constructor(poly) {
    this._camera_types = [];
  }
  register(node) {
    const node_type = node.type();
    if (!this._camera_types.includes(node_type)) {
      this._camera_types.push(node_type);
    }
  }
  registeredTypes() {
    return this._camera_types;
  }
}
